import { palette } from '$tablet-app/src/app/theme';
import React, { FC } from 'react';
import { StyleProp, TouchableOpacity, ViewStyle } from 'react-native';
import styled from 'styled-components/native';
import Text from '../Text';

interface Props {
  active?: boolean;
  children: string;
  onPress: () => void;
  style?: StyleProp<ViewStyle>;
}

const TabContainer = styled(TouchableOpacity)<{ active?: boolean }>`
  padding: 10px;
  padding-top: 0;
  border-bottom-width: 1px;
  border-bottom-color: lightgrey;
  flex: 1;
  color: ${palette.dim};
  ${({ active }) =>
    active
      ? `
          color: black; 
          border-bottom-width: 4px;
          border-bottom-color: ${palette.Primary_blue};`
      : undefined};
`;

const TabText = styled(Text)`
  text-align: center;
`;

const Tab: FC<Props> = ({ active, children, onPress, style }) => (
  <TabContainer active={active} onPress={onPress} style={style}>
    <TabText weight={active ? 'semibold' : undefined}>{children}</TabText>
  </TabContainer>
);

export default Tab;
